import * as actions from './schoolActions';
import reducer from './schoolModeReducer';
import * as selectors from './schoolModeSelectors';

export { actions, reducer, selectors };
